import React from 'react';

const UtensilsCrossedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8" />
    <path d="M15 15 3.3 3.3" />
    <path d="m18 4 4 4" />
    <path d="m3 2 7 7" />
    <path d="m8 2 8 8" />
    <path d="m9 22 3-3-4-4-3 3c-1.3 1.3-1.3 3.5 0 4.8s3.5 1.3 4.8 0Z" />
  </svg>
);

export default UtensilsCrossedIcon;